import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TableHead, TableBody, TableRow, TableFooter, TablePagination } from "@material-ui/core";
import shortid from "shortid";
import styled from "styled-components";
import numberFormatter from "utils/numberFormatter";
import { StyledHeaderCell, StyledTableCell, StyledTable, StyledTableRow } from "../Constants/StyledComponents";
import TablePaginationHelper from "utils/tablePaginationHelper";

const ThinHeaderCell = styled(StyledHeaderCell)`&&& {
    min-width:50px;
}`;
const ThinTableCell = styled(StyledTableCell)`&&& {
    min-width:50px;
}`;
const ContentWrapper = styled.div`{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    padding: 10px;
}`;

const ResultTableWrapper = styled.div`
  width: 88vw;
  height: 64vh;
  overflow-x: scroll;
  overflow-y: scroll;
`;

const TablePaginationWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 5px;  
  margin-right: 80px;
  padding: 10px;
`;
const DebtValuationHeaderResults = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #000000;
`;

class CashflowsResultTable extends Component {
  tablePaginationHelper = new TablePaginationHelper("e52dd1f6-33a8-4e8f-bd70-84fefa95a725");

  createHeaderRow = () => {
    const { showDebtValuationResults } = this.props;
    if (showDebtValuationResults) {

      return (
        <StyledTableRow key={shortid.generate()}>
          <ThinHeaderCell>Debt Valuation Start</ThinHeaderCell>
          <ThinHeaderCell>Debt Valuation End</ThinHeaderCell>
          <ThinHeaderCell>Days In Accrual</ThinHeaderCell>
          <ThinHeaderCell>Days Since Valuation</ThinHeaderCell>
          <ThinHeaderCell>Loan Balance</ThinHeaderCell>
          <ThinHeaderCell>Note Rate</ThinHeaderCell>
          <ThinHeaderCell>Discount Rate</ThinHeaderCell>
          <ThinHeaderCell>FV Payment</ThinHeaderCell>
          <ThinHeaderCell>Discount Factor</ThinHeaderCell>
          <ThinHeaderCell>Credit Adjusted Cashflows</ThinHeaderCell>
          <ThinHeaderCell>Replacement Spread</ThinHeaderCell>
          <ThinHeaderCell>Replacement Base</ThinHeaderCell>
          <ThinHeaderCell>Replacement Rate</ThinHeaderCell>
        </StyledTableRow>
      )
    }
    else {
      return (
        <StyledTableRow key={shortid.generate()}>
          <ThinHeaderCell>Period</ThinHeaderCell>
          <ThinHeaderCell>Begin Date</ThinHeaderCell>
          <ThinHeaderCell>End Date</ThinHeaderCell>
          <ThinHeaderCell>Begin Principal Balance</ThinHeaderCell>
          <ThinHeaderCell>Interest</ThinHeaderCell>
          <ThinHeaderCell>Interest Rate</ThinHeaderCell>
          <ThinHeaderCell>Principal</ThinHeaderCell>
          <ThinHeaderCell>Payment</ThinHeaderCell>
          <ThinHeaderCell>End Principal Balance</ThinHeaderCell>
        </StyledTableRow>
      )
    };
  };

  createCashflowsRow = item => {
    const { showDebtValuationResults } = this.props;
    if (showDebtValuationResults) {
      return (
        <StyledTableRow key={shortid.generate()}>
          <ThinTableCell>{item.debtValuationStart}</ThinTableCell>
          <ThinTableCell>{item.debtValuationEnd}</ThinTableCell>
          <ThinTableCell>{item.daysInAccrual}</ThinTableCell>
          <ThinTableCell>{item.daysSinceValuation}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatMoney(item.loanBalance)}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatRate(item.noteRate)}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatRate(item.discountRate)}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatMoney(item.fvPayment)}</ThinTableCell>
          <ThinTableCell>{item.discountFactor}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatMoney(item.creditAdjustedCashflows)}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatRate(item.replacementSpread)}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatRate(item.replacementBase)}</ThinTableCell>
          <ThinTableCell>{numberFormatter.formatRate(item.replacementRate)}</ThinTableCell>
        </StyledTableRow>
      )
    } else {
      return (
        <StyledTableRow key={shortid.generate()} hover>
          <ThinTableCell> {item.period}</ThinTableCell>
          <ThinTableCell> {item.beginDate}</ThinTableCell>
          <ThinTableCell> {item.endDate}</ThinTableCell>
          <ThinTableCell> {numberFormatter.formatMoney(item.beginPrincipalBalance)}</ThinTableCell>
          <ThinTableCell> {numberFormatter.formatMoney(item.interest)}</ThinTableCell>
          <ThinTableCell> {numberFormatter.formatRate(item.interestRate)}</ThinTableCell>
          <ThinTableCell> {numberFormatter.formatMoney(item.principal)}</ThinTableCell>
          <ThinTableCell> {numberFormatter.formatMoney(item.payment)}</ThinTableCell>
          <ThinTableCell> {numberFormatter.formatMoney(item.endPrincipalBalance)}</ThinTableCell>
        </StyledTableRow>
      )

    }
  };

  mapTableData = testData => {
    if (testData) {
      return testData.PagedList.map(item => (
        this.createCashflowsRow(item)
      ));
    }
    return (
      <StyledTableRow key={shortid.generate()} hover>
        <ThinTableCell />
        <ThinTableCell />
      </StyledTableRow>
    );
  };

  render() {
    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const page = this.tablePaginationHelper.page;
    const { amortResults, count, showDebtValuationResults } = this.props;

    if (!amortResults || !amortResults.PagedList) return null;


    return (
      <ContentWrapper>
        <ResultTableWrapper>
          {showDebtValuationResults && (
            <>
            <DebtValuationHeaderResults>Par Value: {numberFormatter.formatMoney(amortResults.parValue)}</DebtValuationHeaderResults>
            <DebtValuationHeaderResults>Debt Value: {numberFormatter.formatMoney(amortResults.debtValue)}</DebtValuationHeaderResults>
            <DebtValuationHeaderResults>Discount Premium: {numberFormatter.formatMoney(amortResults.discountPremium)}</DebtValuationHeaderResults>
          </>
          )}
          <StyledTable height={20} className="tableBlueHover">
            <TableHead>
              {this.createHeaderRow()}
            </TableHead>
            <TableBody>{this.mapTableData(amortResults || [])}</TableBody>
          </StyledTable>
        </ResultTableWrapper>
        <TablePaginationWrapper>
          <TablePagination
            count={count}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[ 5, 10, 25, 1000 ]}
            page={page}
            backIconButtonProps={{ "aria-label": "Previous Page" }}
            nextIconButtonProps={{ "aria-label": "Next Page" }}
            onChangePage={this.props.handleChangePage}
            onChangeRowsPerPage={this.props.handleChangeRowsPerPage}
            labelDisplayedRows={() => `${page + 1} of ${Math.ceil(count / rowsPerPage)}`}
          />
        </TablePaginationWrapper>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = ({ testHarness }) => ({
  amortResults: testHarness.testData,
  count: testHarness.testData ? testHarness.testData.ListCount : 1
});

export default compose(connect(mapStateToProps))(CashflowsResultTable);
